// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { ILog } from "@lib/logging/ILog";
import { ILogger } from "@lib/logging/ILogger";
import { LogContext } from "@lib/logging/LogContext";
import { LogLevel } from "@lib/logging/LogLevel";

/**
 * Provides methods for formatted logging.
 * Appends meta information in front of the log message.
 */
export class Log implements ILog
{
  private readonly logContext: LogContext;
  private readonly logger: ILogger;

  readonly name: string;
  logLevel: Nullable<LogLevel> = null;

  constructor(name: string, logger: ILogger, logContext: LogContext)
  {
    this.name = name;
    this.logger = logger;
    this.logContext = logContext;
  }

  debug(format: string, ...args: any[]): void
  {
    this.log(LogLevel.Debug, format, args);
  }

  error(format: string, ...args: any[]): void
  {
    this.log(LogLevel.Error, format, args);
  }

  info(format: string, ...args: any[]): void
  {
    this.log(LogLevel.Information, format, args);
  }

  trace(format: string, ...args: any[]): void
  {
    this.log(LogLevel.All, format, args);
  }

  warn(format: string, ...args: any[]): void
  {
    this.log(LogLevel.Warning, format, args);
  }

  private log(logLevel: LogLevel, format: string, args: any[]): void
  {
    const currentLogLevel = this.logLevel === null ? this.logContext.defaultLogLevel : this.logLevel;
    if (logLevel < currentLogLevel)
      return;

    this.logger.log(logLevel, `<${this.logContext.rootName}~${this.name}>: ${format}`, args);
  }
}